import * as Sentry from "@sentry/react";

let environment = import.meta.env.VITE_NODE_ENV;
let authorityEnvironment = 'authority-' + environment;

export function isBrowserExtensionOnlyEvent(event) {
    const frames = event.exception?.values
        ?.flatMap((exception) => exception.stacktrace?.frames ?? [])
        .filter((frame) => typeof frame.filename === 'string') ?? [];

    return frames.length > 0 && frames.every((frame) => (
        frame.filename.startsWith('chrome-extension://')
        || frame.filename.startsWith('moz-extension://')
        || frame.filename.startsWith('safari-web-extension://')
    ));
}

Sentry.init({
    dsn: "https://0d8a9d9adc3eef467def3b3a6cfe1437@o4507191276339200.ingest.de.sentry.io/4507191278436432",
    environment: authorityEnvironment,
    enabled: environment !== 'development',
    sendDefaultPii: true,
    integrations: [],
    beforeSend(event) {
        return isBrowserExtensionOnlyEvent(event) ? null : event;
    },
});
